import { z } from 'zod';
/**
 * Reserved subdomain names that cannot be used by tenants
 */
export const RESERVED_SUBDOMAINS = [
    'www',
    'api',
    'app',
    'admin',
    'system',
    'auth',
    'provider',
    'webhook',
    'public',
    'static',
    'assets',
    'cdn',
    'mail',
    'email',
    'smtp',
    'ftp',
    'blog',
    'docs',
    'help',
    'support',
    'status',
    'test',
    'staging',
    'dev',
    'demo',
    'health',
    'metrics',
    // Path-based routing segments (§4.1 EMAIL plan)
    'login',
    'logout',
    'billing',
    'settings',
    'profile',
    // Insight Field Mode (`/m/*`) — must not collide with tenant path prefixes
    'm',
];
/**
 * Subdomain validation schema
 * Rules:
 * - 1-63 characters
 * - Must start and end with alphanumeric
 * - Can contain hyphens in the middle
 * - Cannot be a reserved subdomain
 */
export const SubdomainSchema = z
    .string()
    .min(1, 'Subdomain is required')
    .max(63, 'Subdomain must be 63 characters or less')
    .regex(/^[a-z0-9]([a-z0-9-]*[a-z0-9])?$/i, 'Subdomain must start and end with alphanumeric characters')
    .refine((val) => !RESERVED_SUBDOMAINS.includes(val.toLowerCase()), (val) => ({ message: `Subdomain '${val}' is reserved` }))
    .transform((val) => val.toLowerCase());
/**
 * Validate if a string is a valid subdomain
 */
export function isValidSubdomain(subdomain) {
    try {
        SubdomainSchema.parse(subdomain);
        return true;
    }
    catch {
        return false;
    }
}
/**
 * Get subdomain validation errors
 */
export function getSubdomainErrors(subdomain) {
    try {
        SubdomainSchema.parse(subdomain);
        return [];
    }
    catch (error) {
        if (error instanceof z.ZodError) {
            return error.errors.map((err) => err.message);
        }
        return ['Invalid subdomain'];
    }
}
//# sourceMappingURL=subdomain.schema.js.map